import Button from '/components/elements/Button'
import { useModalContext } from '/providers/modalProvider'
import styles from './styles.module.scss'
import InquiryModal from '/components/custom/InquiryModal'
import { withComma } from '/components/helpers/withComma'
import startCase from 'lodash-es/startCase'
import { withModifiers } from '/components/helpers/withModifiers'
import { useResponsive } from '../../../../../../../providers/ResponsiveContext'
import { useCurrencyContext } from '/providers/currencyProvider'
import { useRouter } from 'next/router'

const Estate = ({
  property,
  expandable,
  show,
  setShow,
  translations,
  cardTranslations
}) => {
  const { setContent, handleShowModal, setVariant } = useModalContext()
  const { selectedCurrency } = useCurrencyContext()
  const { isDesktop, isTablet } = useResponsive()
  const router = useRouter()

  const price = property.price

  return (
    <div>
      {isDesktop && !isTablet && show && (
        <Button
          className={styles.form__button}
          type="button"
          disabled={property?.sold}
          onClick={() => {
            setShow(!show)
          }}
          variant={[expandable && !show && 'full-width', 'gold']}
          arrow={false}
        >
          {property?.sold ? 'Sold' : 'request more information'}
        </Button>
      )}

      <div
        className={withModifiers(
          'details',
          [isDesktop && expandable && show && 'is-hidden'],
          styles
        )}
      >
        <div className={styles.details__wrapper}>
          <div className={styles.details__content}>
            {property.interior && (
              <div className={styles.details__row}>
                <span>{translations.interior[router.locale]}</span>

                <span>
                  {withComma(property.interior.size)}{' '}
                  {startCase(property.interior.measure)}
                </span>
              </div>
            )}

            {property.exterior && (
              <div className={styles.details__row}>
                <span>{translations.exterior[router.locale]}</span>

                <span>
                  {withComma(property.exterior.size)}{' '}
                  {startCase(property.exterior.measure)}
                </span>
              </div>
            )}

            {property.land_size && (
              <div className={styles.details__row}>
                <span>{translations.landsize[router.locale]}</span>

                <span>
                  {withComma(property.land_size.size)}{' '}
                  {startCase(property.land_size.measure)}
                </span>
              </div>
            )}

            {!property?.sold && (
              <div className={styles.details__row}>
                <span>{translations.price[router.locale]}</span>

                <span
                  className={`${styles.details__price} ${
                    property?.price_upon_request ? styles.details__default : ''
                  }`}
                >
                  {property?.price_upon_request
                    ? cardTranslations.card.onRequest[router.locale]
                    : `${selectedCurrency.coin}${
                        price[selectedCurrency.value]
                      }`}
                </span>
              </div>
            )}
          </div>

          <Button
            variant={['full-width']}
            arrow={false}
            disabled={property?.sold}
            onClick={() => {
              setVariant(['contained'])
              setContent(
                <InquiryModal
                  translations={cardTranslations}
                  name={property.propertyTitle || property.title}
                  form={{
                    title: property.propertyTitle || property.title
                  }}
                />
              )
              handleShowModal()
            }}
          >
            {property?.sold
              ? translations.sold[router.locale]
              : translations.inquire[router.locale]}
          </Button>
        </div>
      </div>
    </div>
  )
}
export default Estate
